import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RolesService } from '../../service/roles.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { RoleDetails } from 'src/app/core/Models/interfaces/roleDetails';

@Component({
  selector: 'app-role-detail-view',
  templateUrl: './role-detail-view.component.html',
  styleUrls: ['./role-detail-view.component.css']
})
export class RoleDetailViewComponent implements OnInit {

  @Output('closeDetails') close: EventEmitter<boolean> = new EventEmitter();
  @Input('userTypeId') userTypeId!: number;
  public viewRole = false;
  public roleDetails!: RoleDetails;
  constructor(
    private toasterandLoader: ToasterService,
    private roleService: RolesService
  ) { }

  private getRoleDetails(): void {
    this.roleService.getRoleDetails(this.userTypeId).subscribe({
      next: (res) => {
        this.roleDetails = res.data[0];
        this.toasterandLoader.isLoaderEnable(false);
        this.viewRole = true;
      },
      error: (err) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: err.message,
        });
        this.toasterandLoader.isLoaderEnable(false);
        this.viewRole = false;
        this.close.emit();
      }
    })
  }

  ngOnInit() {
    this.getRoleDetails();
  }

  closeDetails(): void {
    this.viewRole = false;
    setTimeout(() => {
      this.close.emit();
    }, 100);
  }

}
